import { render, staticRenderFns } from "./GlossaryViewport.vue?vue&type=template&id=6f8ee37b&scoped=true&"
import script from "./GlossaryViewport.vue?vue&type=script&lang=js&"
export * from "./GlossaryViewport.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryViewport.vue?vue&type=style&index=0&id=6f8ee37b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ee37b",
  null
  
)

export default component.exports